import type { LearnerExam } from "../../../packages/content-schema/learner";

export type SectionScope = "full" | "rw" | "math";

export function projectExamSection(exam: LearnerExam, scope: SectionScope): LearnerExam {
  if (scope === "full") return exam;
  const section = scope === "rw" ? "reading_writing" : "math";
  const modules = exam.modules.filter((module) => module.section === section);
  return { ...exam, title: `${exam.title} · ${scope === "rw" ? "Reading and Writing" : "Math"}`, modules, routeGraph: [] };
}

export function sectionScopeFromInput(value: unknown): SectionScope {
  return value === "rw" || value === "math" ? value : "full";
}

export function sectionScopeLabel(scope: SectionScope) {
  return scope === "rw" ? "Reading and Writing" : scope === "math" ? "Math" : "Full test";
}
